<template>
 <div id="situation">
   <link rel="stylesheet" href="/static/css/index2-style.css">
    <div class="container content-index-2">
        <v-runtime-template :template="situation.html"></v-runtime-template>
        <div class="dlya">ДЛЯ КОГО?</div>
        <div class="cobs">
            <router-link :to="example.link" v-for="(example, key) in examples" :key="key">
                <div class="cub-1">
                    <img :src="example.img" class="cub-img" alt="">
                    <div class="text" v-html="example.text"></div>
                </div>
            </router-link>
        </div>
    </div>
     <div class="container text-center end-b">
         <button class="get-doc" @click="showModal()">Получить документы<br>по моему делу</button>
     </div>
 </div>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
    name: 'situation',
    components: {
        VRuntimeTemplate
    },
    data () {
        return {
            situation: {
                html: null
            },
            examples: [
                {
                    link: '/sud-ne-naznachili',
                    img: '/static/img/img-1.png',
                    text: 'Суд еще не назначали'
                },
                {
                    link: '/sud-naznachen',
                    img: '/static/img/img-2.png',
                    text: 'Суд назначали.<br>Времени мало'
                },
                {
                    link: '/lishili-prav-sdal-prava',
                    img: '/static/img/img-3.png',
                    text: 'Суд был. Суд проиграл<br>Права сдал'
                },
                {
                    link: '/lishili-prav-ne-sdal-prava',
                    img: '/static/img/img-4.png',
                    text: 'Суд был. Суд проиграл<br>Права не сдал'
                }
            ]
        }
    },
    methods: {
        initPage () {
            axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.$router.currentRoute.params.id).then(response => {
                this.situation = response.data
                this.situation.html = '<div>' + this.situation.html.replace(/{showDoc}/gi, '<button class="get-doc" @click="showModal()">').replace(/{\/showDoc}/gi, '</button>') + '</div>'
            })
        },
        showModal () {
            this.$root.requestModal = 1
        }
    },
    mounted () {
        this.initPage()
    },
    watch: {
        $route (to, from) {
            this.initPage()
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/situation.vue